/*!

=========================================================
* Purity UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// import
// To be changed
// import Tables from "views/Dashboard/Tables.js";
import {
  CartIcon,
  DocumentIcon,
  HomeIcon,
  PersonIcon,
  StatsIcon,
  BoxIcon, UsersIcon, TruckIcon
} from "components/Icons/Icons";
import Calendar from "views/Applications/Calendar/index";
import DataTables from "views/Applications/DataTables/index";
import Kanban from "views/Applications/Kanban/index";
import Wizard from "views/Applications/Wizard/index";
import SignInBasic from "views/Authentication/SignIn/SignInBasic.js";
import SignInCover from "views/Authentication/SignIn/SignInCover.js";
import SignInIllustration from "views/Authentication/SignIn/SignInIllustration.js";
import SignUpBasic from "views/Authentication/SignUp/SignUpBasic.js";
import SignUpCover from "views/Authentication/SignUp/SignUpCover.js";
import SignUpIllustration from "views/Authentication/SignUp/SignUpIllustration.js";
import CRM from "views/Dashboard/CRM";
import Default from "views/Dashboard/Default";
import OrderDetails from "views/Ecommerce/Orders/OrderDetails/index";
import OrderList from "views/Ecommerce/Orders/OrderList/index";
import EditProduct from "views/Ecommerce/Products/EditProduct/index";
import NewProduct from "views/Ecommerce/Products/NewProduct/index";
import ProductPage from "views/Ecommerce/Products/ProductPage/index";
import ToDoList from "views/Pages/Projects/General/components/ToDoList.js";
import Billing from "views/Pages/Account/Billing/index";
import Invoice from "views/Pages/Account/Invoice/index";
import Settings from "views/Pages/Account/Settings/index";
import Alerts from "views/Pages/Alerts/index";
import Charts from "views/Pages/Charts/index";
import Pricing from "views/Pages/Pricing/index";
import Overview from "views/Pages/Profile/Overview/index";
import Projects from "views/Pages/Profile/Projects/index";
import Teams from "views/Pages/Profile/Teams/index";
import General from "views/Pages/Projects/General/index";
import Timeline from "views/Pages/Projects/Timeline/index";
import RTLPage from "views/Pages/RTL/index";
import NewUser from "views/Pages/Users/NewUser/index";
import Reports from "views/Pages/Users/Reports/index";
import Widgets from "views/Pages/Widgets/index";
import LoginInput from "views/Authentication/Login/LoginInput";
import CustomerList from "views/Customers/CustomerList/customerList";
import AddCustomer from "views/Customers/CustomerList/AddCustomer";
import Client from "views/Pages/Client";
import Products from "views/Pages/Products";
import Orders from "views/Pages/Orders";
import Drivers from "views/Pages/Drivers";

const dashRoutes = [

  // {
  //   name: "Ρυθμίσεις",
  //   path: "/authentication",
  //   icon: <PersonIcon color="inherit" />,
  //   category: "Παραγγελίες",
  //   collapse: false,
  //   redirect: true,
  //   items: [
  //     {
  //       name: "Login",
  //       path: "/authentication/login",
  //       collapse: true,
  //       redirect: true,
  //       authIcon: <DocumentIcon color="inherit" />,
  //       items: [
  //         {
  //           path: "/authentication/login",
  //           name: "Login",
  //           layout: "/auth",
  //           component: () => {
  //             console.log("TEST ROUTE RENDERED");
  //             return <div style={{ fontSize: "24px", color: "red" }}>TEST ROUTE RENDERING</div>;
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sign In",
  //       path: "/authentication/sign-in",
  //       collapse: true,
  //       authIcon: <DocumentIcon color="inherit" />,
  //       items: [
  //         {
  //           name: "Basic",
  //           secondaryNavbar: true,
  //           component: LoginInput,
  //           path: "/authentication/sign-in/basic",
  //           layout: "/auth",
  //         },
  //         {
  //           name: "Cover",
  //           component: SignInCover,
  //           path: "/authentication/sign-in/cover",
  //           layout: "/auth",
  //         },
  //         {
  //           name: "Illustration",
  //           component: SignInIllustration,
  //           path: "/authentication/sign-in/illustration",
  //           layout: "/auth",
  //         },
  //       ],
  //     },
  //     {
  //       name: "Sign Up",
  //       path: "/authentication/sign-up",
  //       collapse: true,
  //       authIcon: <DocumentIcon color="inherit" />,
  //       items: [
  //         {
  //           name: "Basic",
  //           secondaryNavbar: true,
  //           component: SignUpBasic,
  //           path: "/authentication/sign-up/basic",
  //           layout: "/auth",
  //         },
  //         {
  //           name: "Cover",
  //           component: SignUpCover,
  //           path: "/authentication/sign-up/cover",
  //           layout: "/auth",
  //         },
  //         {
  //           name: "Illustration",
  //           component: SignUpIllustration,
  //           path: "/authentication/sign-up/illustration",
  //           layout: "/auth",
  //         },
  //       ],
  //     },
  //   ],
  // },

  {
    name: "",
    category: "lista_paraggelion",
    items: [
      {
        name: "Λίστα Παραγγελιών",
        path: "/lista_paraggelion",
        collapse: false,
        component: Orders,
        layout: "/admin",
        icon: <DocumentIcon color="inherit" />,
   
      },
      {
        name: "Προϊόντα",
        component: Products,
        // secondaryNavbar: true,
        path: "/Administratio/Producta",
        icon: <BoxIcon color="inherit" />,
        layout: "/admin",
        // redirect: false,
        // component: OrderList,
        collapse: false,
      },
      {
        name: "Πελάτες",
        component: Client,
        path: "/Administratio/upload",
        layout: "/admin",
        // redirect: false,
        // component: CustomerList,
        icon: <UsersIcon color="inherit" />,
        collapse: false,
      },

      {
        name: "Οδηγοί",
        // component: ProductPage,
        path: "/Administratio/Ducēs",
        layout: "/admin",
        // redirect: false,
        component: Drivers,
        icon: <TruckIcon color="inherit" />,
        collapse: false,
      },


    ],
  },
];

export default dashRoutes;
